import { NgModule } from "@angular/core";
import { TemplatesListModule } from "./list/templates-list.module";
import { TemplateModule } from "./template/template.module";
import { TemplatesRoutingModule } from "./templates.routing";

@NgModule({
    imports: [TemplatesRoutingModule, TemplatesListModule, TemplateModule],
})
export class TemplatesModule {}
